// User's roles
export const USER_ROLE_ANONYMOUS = 'anon'; // ? For frontend fallback only
export const USER_ROLE_NORMAL = 'usr';
export const USER_ROLE_KIOSK = 'ksk';
export const USER_ROLE_EMPLOYEE = 'emp';
export const USER_ROLE_DATABASE_MANAGER = 'dmg';
